module.exports = __webpack_public_path__ + "img/U5.49c45698.png";